import script from "./ChangeBusForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangeBusForm.vue?vue&type=script&lang=ts&setup=true"

import "./ChangeBusForm.vue?vue&type=style&index=0&id=374af9cd&lang=scss"

const __exports__ = script;

export default __exports__